<!-- Main Page Start -->
<div class="content-wrapper table-full-bx details-page all-saved-searches">
  <div class="page-content recruiterpanel">
      <div class="row">
          <div class="col-lg-12">
              <div class="ibox">
                  <div class="ibox-body">
                      <div class="page-heading slash_breadcrumb">
                          <ol class="breadcrumb">
                              <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/search"> Search </a></li>
                              <li class="breadcrumb-item">Saved search</li>
                          </ol>
                      </div>

                      <div class="ibox-title mb-3">
                          <span> Saved Searches </span>
                      </div>

                      <div class="col-bx-top">
                          <div class="row">
                              <!-- 1 Card -->
                              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="let data of searchList; let i=index;">
                                  <div class="contentWrap card-grid-2" (click)="goToSearch(data.title)" style="cursor: pointer;">
                                      <div  class="three_dot_icon" ngbDropdown>
                                        <a class="dropdown-toggle dropdownlist" href="javascript:void(0);" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" id="dropdown_profile_area" ngbDropdownToggle><img src="assets/images/ic_three_dot.svg" /> </a>
                                        <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                                        ngbDropdownMenu >
                                            <li><a class="dropdown-item" href="javascript:void(0);" (click)="delete(data.id)"> Delete </a></li>
                                        </ul>
                                    </div>
                                      <h6>"{{data.title}}"</h6>
                                      <!-- <span class="id"> {{data.id}} </span> -->
                                      <p class="salary" *ngFor="let user of data.searchResult;">
                                          ({{user.title}})
                                      </p>
                                      <p class="card-time"><strong>Date created </strong> : {{data.createdAt | date: "d/M/YYYY"}}</p>
                                  </div>
                              </div> 
                              
                            <div class="noDataFound" *ngIf="searchList.length == 0">
                                <h2>No Saved Searches</h2>
                            </div>
                              <!-- end card  -->
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>